import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { map, filter } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';

import { environment } from '../../../environments/environment';

import { LoginModel } from '../models/login.model';
import { User } from '../models/user.model';
import { ApiConfig } from './config/api.config';
import { CacheService } from '../models/cache-service.model';
import { UserManagement } from '../models/user-management.model';
import { TipoAcceso } from '../enumeration/tipo-acceso.enum';
import { OfficeManagementComponent } from '../../office-management/office-management.component';

declare var jQuery: any;


@Injectable()
export class AuthService { 

    constructor(
        private http: HttpClient,
        private api: ApiConfig,
        private _route: ActivatedRoute,
        private _router: Router
    ) { }

    logIn(login: LoginModel, token: string, tipoAcceso: number): Observable<any> {

        if (tipoAcceso === TipoAcceso.AccesoNormal) {
            return this.http.post(this.api.url + '/auth/login?type=' + tipoAcceso, login);
        } else if (tipoAcceso === TipoAcceso.AccesoExterno) {
            const _headers = { 'Authorization': 'Entry ' + token };
            return this.http.post(this.api.url + '/auth/login?type=' + tipoAcceso, login, { headers: _headers });
        } else if (tipoAcceso === TipoAcceso.AccesoManagement) {
            const _headers = { 'Authorization': 'Entry_MP ' + token };
            return this.http.post(this.api.url + '/auth/login?type=' + tipoAcceso, login, { headers: _headers });
        } else {
            return this.http.post(this.api.url + '/auth/login?type=' + tipoAcceso, login);
        }
    }

    logInAccessMP(login: any): Observable<UserManagement> {
        return this.http.post<UserManagement>(this.api.urlAccessMP + '/auth/login_mp', login);
    }

    logOut() {
        sessionStorage.removeItem('cache');
        sessionStorage.removeItem('contracts');
        sessionStorage.removeItem('currentUser');
        sessionStorage.removeItem('dataContract');
        sessionStorage.removeItem('selectContract');
        sessionStorage.removeItem('selectDocumentTypeContract');
        sessionStorage.removeItem('nombreBeneficiario');
        sessionStorage.removeItem('documentoBeneficiario');
        sessionStorage.removeItem('sessionPagos');
        this._router.navigate(['/auth/sign_in']);
    }

    logOutAccessMP() : void {        
        sessionStorage.clear();
        window.top.location.href= environment.urlWebManagement + '/auth/mp_access';        
    }

    isAuthenticate(): boolean {
        if (sessionStorage.getItem('currentUser')) {
            return true;
        }
        return false;
    }

    isAuthenticateManagement(): boolean {
        if (sessionStorage.getItem('currentUserMP')) {
            return true;
        }
        return false;
    }

    postValidaPassOld(usuario: string, password: string): Observable<any> {
        return this.http.post<any>(this.api.url + '/auth/validate', { user: usuario, pass: password });
    }

    postCambiaPassBd(usuario: string, password: string, contrato: number): Observable<any> {
        return this.http.post<any>(this.api.url + '/auth/changepass', { user: usuario, pass: password, contractNumber: contrato });
    }

    postNewPass(documentid: string, contrato: string): Observable<any> {
        return this.http.post<any>(this.api.url + '/auth/newpass', { identification: documentid, contractNumber: contrato});
    }
}


// WEBPACK FOOTER //
// /app/src/app/shared/services/auth.service.ts